import React from "react";
import { Box, Typography, Button, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { i18n } from "../../translate/i18n";
import { useLocalStorage } from "../../hooks/useLocalStorage";

const SignatureOnboardingBanner = ({ user, signatureFeatureEnabled, onConfigClick }) => {
  const [dismissed, setDismissed] = useLocalStorage(
    `signature_onboarding_dismissed_${user?.id}`,
    false
  );

  if (!signatureFeatureEnabled) return null;
  if (user?.signatureEnabled) return null;
  if (dismissed) return null;
  if (!user?.id) return null;

  return (
    <Box
      style={{
        backgroundColor: "#e3f2fd",
        border: "1px solid #90caf9",
        borderRadius: 4,
        padding: "6px 12px",
        margin: "4px 8px",
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <Typography variant="body2" style={{ flex: 1, fontSize: 12 }}>
        {i18n.t("signatureOnboarding.message")}
      </Typography>
      <Button
        size="small"
        color="primary"
        variant="outlined"
        onClick={onConfigClick}
        style={{ whiteSpace: "nowrap", flexShrink: 0 }}
      >
        {i18n.t("signatureOnboarding.configure")}
      </Button>
      <IconButton
        size="small"
        onClick={() => setDismissed(true)}
        title={i18n.t("signatureOnboarding.dismiss")}
      >
        <CloseIcon style={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
};

export default SignatureOnboardingBanner;
